import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import Button from '../atoms/Button';
import './CookieConsentBanner.css';

const CookieConsentBanner: React.FC = () => {
  const [cookies, setCookie] = useCookies(['cookieConsent']);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show banner if no consent has been given
    if (!cookies.cookieConsent) {
      setIsVisible(true);
    }
  }, [cookies.cookieConsent]);

  const handleAcceptAll = () => {
    setCookie('cookieConsent', {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    }, { 
      path: '/',
      maxAge: 365 * 24 * 60 * 60, // 1 year
      sameSite: 'lax'
    });
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    setCookie('cookieConsent', {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    }, { 
      path: '/',
      maxAge: 365 * 24 * 60 * 60, // 1 year
      sameSite: 'lax'
    });
    setIsVisible(false);
  };

  const handleCustomize = () => {
    // Navigate to cookie preferences page
    window.location.href = '/cookies';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>🍪 We use cookies</h3>
          <p>
            We use cookies to enhance your browsing experience, serve personalized content, 
            and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
          </p>
        </div>
        
        <div className="cookie-consent-actions">
          <Button 
            variant="secondary" 
            size="small" 
            onClick={handleAcceptNecessary}
          >
            Necessary Only
          </Button>
          
          <Button 
            variant="secondary" 
            size="small" 
            onClick={handleCustomize}
          >
            Customize
          </Button>
          
          <Button 
            variant="primary" 
            size="small" 
            onClick={handleAcceptAll}
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
